import { PluginKey, Plugin, TextSelection } from '@tiptap/pm/state';
import { NodeControlState } from './NodeControlState.js';
import { NodeControlMeta } from './NodeControlMeta.js';
import { getPath } from '../utils.js';
import { DecorationSet } from '@tiptap/pm/view';
import { ContextualMenuPluginKey } from '../ContextualMenu/ContextualMenuPlugin.js';

const xOffsets = [
  150,
  100,
  50,
  0,
  -50,
  -100,
  -150
];
const NodeControlPluginKey = new PluginKey("nodeControl");
class CustomTextSelection extends TextSelection {
}
const NodeControlPlugin = () => {
  return new Plugin({
    key: NodeControlPluginKey,
    appendTransaction: (transactions, oldState, newState) => {
      const uiDropTransaction = transactions.find((tr) => tr.getMeta("uiEvent") === "drop");
      if (uiDropTransaction && oldState.selection instanceof CustomTextSelection && !(newState.selection instanceof CustomTextSelection)) {
        const tr = newState.tr;
        const resolved = newState.doc.resolve(tr.selection.head);
        tr.setSelection(TextSelection.create(newState.doc, resolved.end()));
        return tr;
      }
      return null;
    },
    state: {
      init() {
        return NodeControlState.empty;
      },
      apply(tr, controlState, _, newState) {
        const meta = tr.getMeta(NodeControlPluginKey);
        const prev = ContextualMenuPluginKey.getState(newState);
        if (prev?.active && prev?.active.hideNodeControls) return NodeControlState.empty;
        if (NodeControlMeta.isNodeControlMeta(meta)) {
          controlState = controlState.applyMeta(meta);
        }
        return controlState.applyTransform(tr).applyDecorations(tr, newState);
      }
    },
    props: {
      decorations(state) {
        return this.getState(state)?.decorations ?? DecorationSet.empty;
      },
      handleDOMEvents: {
        mousemove: (editorView, event) => {
          if (!editorView.editable) return;
          const target = event.target;
          if (!(target instanceof Element) || target.closest("[data-diff-display]")) {
            NodeControlMeta.dispatchReset(editorView);
            return;
          }
          if (target.closest("[data-node-control]")) {
            return;
          }
          const controlState = NodeControlPluginKey.getState(editorView.state);
          let foundNodePath = null;
          for (let offsetIndex = 0; offsetIndex < xOffsets.length && !foundNodePath; offsetIndex++) {
            const offset = xOffsets[offsetIndex];
            const coords = editorView.posAtCoords({
              left: event.clientX + offset,
              top: event.clientY
            });
            if (!coords) {
              continue;
            }
            const resolved = editorView.state.doc.resolve(coords.pos);
            const path = getPath(resolved);
            foundNodePath = NodeControlState.findValidNodePath(path);
          }
          if (!foundNodePath) {
            NodeControlMeta.dispatchReset(editorView);
            return;
          }
          const element = editorView.nodeDOM(foundNodePath.pos);
          if (!element || !(element instanceof HTMLElement)) {
            NodeControlMeta.dispatchReset(editorView);
            return;
          }
          if (element === controlState?.currentNodeElement) {
            return;
          }
          NodeControlMeta.dispatchUpdate(editorView, foundNodePath.pos, foundNodePath.start, element);
        }
      }
    }
  });
};

export { CustomTextSelection, NodeControlPlugin, NodeControlPluginKey, xOffsets };
//# sourceMappingURL=NodeControlPlugin.js.map
